module.exports = __webpack_public_path__ + "static/orog-2970f9456baecc22e87bbfd5c79250bc.jpeg";